export default "__VITE_ASSET__DprkkKuS__"